// The plan chosen with "Start" on outlevo.com (https://app.outlevo.com/signup?plan=builder). It is kept in this browser
// through sign-in and creating the workspace, and shown as a strip until the person chooses it on Billing or dismisses it.
export type PickedPlan = 'builder' | 'growth';
export const PICKED_PLAN = 'olv_plan';
const isPlan = (v: string | null): v is PickedPlan => v === 'builder' || v === 'growth';

/** Reads ?plan= from the address and keeps it (call once when the app loads). */
export function planFromUrl() {
  try {
    const p = new URLSearchParams(location.search).get('plan');
    if (isPlan(p)) localStorage.setItem(PICKED_PLAN, p);
  } catch { /* private mode */ }
}
export function pickedPlan(): PickedPlan | null {
  try { const p = localStorage.getItem(PICKED_PLAN); return isPlan(p) ? p : null; } catch { return null; }
}
export function clearPickedPlan() { try { localStorage.removeItem(PICKED_PLAN); } catch { /* ignore */ } }
